import { useMemo, useState } from 'react'
import { createEvent, setEventModule } from './eventRepository'
import { eventDraftFromTemplate, eventTemplates, type EventTemplateId } from './eventTemplates'
import type { EventRecord } from './types'

export function EventOnboarding({ organizationId, onCreated, onCancel }: { organizationId: string; onCreated: (event: EventRecord) => void; onCancel?: () => void }) {
  const [templateId, setTemplateId] = useState<EventTemplateId>('counter')
  const [name, setName] = useState('')
  const [tableCount, setTableCount] = useState(30)
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  const template = useMemo(() => eventTemplates.find((item) => item.id === templateId)!, [templateId])
  const usesTables = template.operations.serviceModes.includes('table')

  async function submit() {
    const cleanName = name.trim()
    if (!cleanName) return setError('Inserisci il nome dell’evento.')
    setBusy(true); setError('')
    try {
      const draft = eventDraftFromTemplate({ templateId, name: cleanName, tableCount: usesTables ? tableCount : undefined })
      const event = await createEvent(organizationId, draft)
      await Promise.all(template.enabledModules.map((moduleId) => setEventModule(event.id, moduleId, true)))
      onCreated(event)
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Creazione evento non riuscita.')
    } finally { setBusy(false) }
  }

  return <section aria-label="Creazione guidata evento" style={{maxWidth:920,margin:'0 auto',padding:20}}>
    <h1>Crea un nuovo evento</h1>
    <p>Scegli il modello più vicino alla tua festa. Potrai modificare ogni impostazione in seguito.</p>
    <div style={{display:'grid',gridTemplateColumns:'repeat(auto-fit,minmax(220px,1fr))',gap:12,margin:'20px 0'}}>
      {eventTemplates.map((item) => <button key={item.id} type="button" aria-pressed={templateId===item.id} onClick={()=>setTemplateId(item.id)} style={{padding:18,textAlign:'left',borderRadius:16,border:templateId===item.id?'3px solid currentColor':'1px solid #d1d5db',background:'white'}}>
        <strong style={{display:'block',fontSize:18}}>{item.label}</strong><span>{item.description}</span>
      </button>)}
    </div>
    <label style={{display:'block',marginBottom:14}}>Nome evento<input value={name} onChange={(e)=>setName(e.target.value)} placeholder="Es. Festa d'autunno 2027" style={{display:'block',width:'100%',padding:12,marginTop:6}} /></label>
    {usesTables && <label style={{display:'block',marginBottom:14}}>Numero tavoli<input type="number" min={1} max={300} value={tableCount} onChange={(e)=>setTableCount(Math.max(1,Math.min(300,Number(e.target.value)||1)))} style={{display:'block',width:'100%',padding:12,marginTop:6}} /></label>}
    <div style={{padding:14,borderRadius:12,background:'#f3f4f6',marginBottom:16}}><strong>Configurazione iniziale</strong><div>{template.operations.serviceModes.join(' · ')} · {template.enabledModules.length} moduli attivi · consegna {template.delivery.allowByDepartment?'configurabile':'insieme'}</div></div>
    {error && <p role="alert" style={{fontWeight:700}}>{error}</p>}
    <div style={{display:'flex',gap:10}}>{onCancel && <button type="button" onClick={onCancel} disabled={busy}>ANNULLA</button>}<button type="button" onClick={submit} disabled={busy} style={{padding:'12px 22px',fontWeight:800}}>{busy?'CREAZIONE…':'CREA EVENTO'}</button></div>
  </section>
}
